import UserAuthorizationError from './UserAuthorizationError'

export default UserAuthorizationError
